import { render } from "./CommercialGestureModal.vue?vue&type=template&id=5203ab47&scoped=true&ts=true&lang=pug"
import script from "./CommercialGestureModal.vue?vue&type=script&lang=ts"
export * from "./CommercialGestureModal.vue?vue&type=script&lang=ts"

import "./CommercialGestureModal.vue?vue&type=style&index=0&id=5203ab47&scoped=true&lang=scss"
import "./CommercialGestureModal.vue?vue&type=style&index=1&id=5203ab47&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5203ab47"]])

export default __exports__